<template>
  <div class="form-group">
    <select class="form-control" :value="value" v-on:input="versionChanged($event.target.value)">
      <option v-for="version in versions" :value="version.identifier">{{ version.name }}</option>
    </select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'

export default {
  mixins: [constants],
  props: ['value'],
  computed: {
    ...mapGetters(['allSettings', 'shopId', 'locale', 'user', 'pos']),
    settings() {
      return this.shopSettings(this.shopId)
    },
    versions() {
      if (!this.settings || !this.settings.versions) {
        return []
      }
      let available = this.settings.versions.split(';')
      return this.allVersions.filter(v => available.includes(v.identifier))
    }
  },
  methods: {
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    versionChanged (version) {
      this.$emit('input', version)
    }
  }
}
</script>
